import React from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import NodeCard from "./node-card";
import "./tree-style.css";

export default function TreeBuilder({
  data,
  isLeaf,
  isFirstNode,
  addChild,
  removeNode,
  updateNode,
  statusList,
  groupedError,
}) {
  // Build children map
  const buildTree = (list, parentId) =>
    list.filter((item) => item.parent_id === parentId);

  const renderNodes = (parentId) => {
    const nodes = buildTree(data, parentId);

    return nodes.map((node) => {
      const nodeIndex = data.findIndex((x) => x.box_id === node.box_id);
      return (
        <TreeNode
          key={node.box_id}
          label={
            <NodeCard
              node={node}
              isLeaf={isLeaf}
              isFirstNode={isFirstNode}
              addChild={addChild}
              removeNode={removeNode}
              updateNode={updateNode}
              statusList={statusList}
              groupedError={groupedError}
              nodeIndex={nodeIndex}
            />
          }
        >
          {renderNodes(node.box_id)}
        </TreeNode>
      );
    });
  };

  const root = data.find((x) => x.parent_id === 0);

  return (
    <div className="tree-wrapper">
      <Tree
        lineWidth={"2px"}
        lineColor={"#555"}
        lineBorderRadius={"20px"}
        lineHeight={"30px"}
        lineStyle={"dotted"}
        label={
          root ? (
            <NodeCard
              node={root}
              isLeaf={isLeaf}
              isFirstNode={isFirstNode}
              addChild={addChild}
              removeNode={removeNode}
              updateNode={updateNode}
              statusList={statusList}
              groupedError={groupedError}
              nodeIndex={0}
            />
          ) : (
            ""
          )
        }
      >
        {renderNodes(root?.box_id)}
      </Tree>
    </div>
  );
}
